import _ from 'underscore'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { Button } from '@nexiahome/ui-common/components/primitives/buttons'

import FavoriteIcon from 'pages/DeviceSearch/FavoriteIcon'
import DeviceLegacy from 'pages/Device/indexLegacy'
import Device from 'pages/Device/index'

import { useSessionContext } from 'hooks/SessionContext'

import { PageTitle } from 'styles/shared'

import { Device as DeviceType, DeviceBase } from 'types/Device'
import { useFeaturesContext } from 'hooks/FeaturesContext'

type Props = {
  device: DeviceBase & Pick<DeviceType, 'dealerCode' | 'dealerName'>
}

const SingleDeviceResult = ({ device }: Props) => {
  const navigate = useNavigate()
  const location = useLocation()

  location.pathname = `/devices/${device.deviceId}/`

  const { session: { isAdmin, isFsr, isTechnician } } = useSessionContext()

  const isUserValidForFavorites = isFsr || isAdmin || isTechnician
  const isAssociatedToDealer = device.dealerId !== null
  const { enabledFeatures } = useFeaturesContext()

  return (
    <>
      <S.Header>
        {isUserValidForFavorites && <S.FavoriteIcon deviceId={device.deviceId} size="30" />}

        <S.PageTitle>System {device.deviceId}</S.PageTitle>

        {isAdmin && isAssociatedToDealer && (
          <Button decoration="secondary"
            text="TRANSFER"
            styles={{ button: { marginLeft: 64, marginTop: 10 } }}
            onPress={() => navigate(`/admin/device/${device.deviceId}/dealer/${device.dealerId}/transfer`)}
          />
        )}
      </S.Header>

      {device
        ? <p>Dealer: {_.compact([device.dealerName, device.dealerCode]).join(', ')}</p>
        : <p>No Dealer Associated with this Device</p>
      }
      {enabledFeatures.includes('system_dashboard')
        ? <Device deviceId={device.deviceId} dealerId={device.dealerId} isActive />
        : <DeviceLegacy deviceId={device.deviceId} dealerId={device.dealerId} isActive />
      }
    </>
  )
}

export default SingleDeviceResult

const S = {
  Header: styled.div`
    display: flex;
    align-items: center;
  `,
  PageTitle: styled(PageTitle)`
    margin: 15px 0 5px 5px;
  `,
  FavoriteIcon: styled(FavoriteIcon)`
    margin: 15px 5px 0 0;
  `
}
